import { get } from './utils';

export const getTransactionsSummaryApi = () =>
  get('/admin/transactions/summary');
